var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:{
        'sm:space-y-16 space-y-8': !_vm.small,
        'sm:space-y-8 space-y-4': _vm.small,
    }},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }